import React from "react";
import styles from "./ProfileDropdownButton.module.css";
import { useNavigationContext } from "../../contexts/NavagationContext";

export const ProfileDropdownButton = (props) => {

    // props:
    // 
    // isOpen - state var if dropdown is open

    // ----------------------------------------------------- STATES AND HOOKS

    const currentLocation = useNavigationContext();
    // ----------------------------------------------------- PRE-RENDER
    // ----------------------------------------------------- RENDER
    
    return (
        <section className={styles.container} onClick={props.toggle}>
            <img src={props.isOpen || currentLocation === "profile" ? "/assets/images/profileLight.svg" :"/assets/images/profile.svg"} className={styles.profileIcon} alt="profile icon" title="Profile Menu"/>
        </section>
    );
}